import React, { useEffect } from 'react';
import { Snackbar, Button } from '@mui/joy';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';

interface SnackbarComponentProps {
  open: boolean;
  onClose: () => void;
  message: string;
  color?: 'success' | 'error';
}

const SnackbarComponent: React.FC<SnackbarComponentProps> = ({
  open,
  onClose,
  message,
  color = 'success',
}) => {
  useEffect(() => {
    if (open) {
      const timer = setTimeout(onClose, 3000);
      return () => clearTimeout(timer);
    }
  }, [open, onClose]);

  const Icon = color === 'success' ? CheckCircleRoundedIcon : ErrorRoundedIcon;

  return (
    <Snackbar
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      startDecorator={<Icon />}
      endDecorator={
        <Button onClick={onClose} size="sm" variant="soft" color="neutral">
          Dismiss
        </Button>
      }
      sx={{
        backgroundColor: color === 'success' ? 'green' : 'red',
        color: 'white',
      }}
    >
      {message}
    </Snackbar>
  );
};

export default SnackbarComponent;
